module.exports = __webpack_public_path__ + "static/media/key-message-benefits-1920w.134ce438.png";